import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { translations } from '../translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    // localStorage'dan dil tercihini oku, yoksa 'tr' kullan
    if (typeof window !== 'undefined') {
      return localStorage.getItem('elc-lang') || 'tr';
    }
    return 'tr';
  });

  // Dil değiştiğinde localStorage'a kaydet ve html lang attribute'u güncelle
  useEffect(() => {
    localStorage.setItem('elc-lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let val = translations[lang];
    for (const k of keys) {
      if (val === undefined) return key;
      val = val[k];
    }
    return val ?? key;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => prev === 'tr' ? 'en' : 'tr');
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
